import { Box, TextField } from "@mui/material";
import React, { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState,setTotalValues } from "./defineSlice";
import './Define.css'
import {
	removeComma,
	rowDepletionModelKey,
	rowIsWeek4OnlyForExport,
	shouldShowBlankWeekPlaceholder,
	findGridRowByCustomerSku,
	commitGridDataUpdate,
} from "./defineUtils";
import debounce from 'lodash/debounce';
import { QUOTA_CELL_DEBOUNCE_MS, useQuotaCellInputSync } from "./useQuotaCellInput";

export default function TableCellWeek4(params) {
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const { gridData, gridDataFiltered, isWeek4Only, selectedDepletionPeriodType } = define;
   const gridDataRef = useRef(gridData);
   const gridDataFilteredRef = useRef(gridDataFiltered);
   gridDataRef.current = gridData;
   gridDataFilteredRef.current = gridDataFiltered;
   const rowDm = rowDepletionModelKey(params.row);
   const periodLabel = String(
      selectedDepletionPeriodType?.depletionPeriodType ?? ""
   ).toLowerCase();
   const isFourWeekPeriod = periodLabel.includes("4-week");
   const cellInput = useQuotaCellInputSync(params.row.weekly4);
   const { setDraft, displayValue, onFocus, onBlur } = cellInput;
   const customerID = params.row.customerID;
   const customerGroupID = params.row.customerGroupID;
   const productGroupID = params.row.productGroupID;
   const skuid = params.row.skuid;

   function updateGrid(hasError, w) {
      let updatedItem = null;
      const filtered = gridDataFilteredRef.current;
      const fullGrid = gridDataRef.current;
      const updated = filtered.map((item, index) => {
         const flag =
            item.customerID === customerID &&
            item.customerGroupID === customerGroupID &&
            item.productGroupID === productGroupID &&
            item.skuid === skuid;
         if (flag === true) {
            updatedItem = {
               ...item,
               hasError,
               weekly4: !w ? 0 : w,
            };
            return updatedItem;
         }
         return item;
      });

      const updatedGrid = [];
      for (let i = 0; i < fullGrid.length; ++i) {
         const item = fullGrid[i];
         if(item.id === updatedItem.id) {
            updatedGrid.push(updatedItem);
         }
         else {
            updatedGrid.push(item);
         }
      }
      commitGridDataUpdate(dispatch, setState, {
         gridData: updatedGrid,
         gridDataFiltered: updated,
         updatedRow: updatedItem,
         backupFields: ["weekly4"],
      });
   }

   // function updateWeek4(event) {
   //    let w4 = removeComma(event.target.value);
   //    w4 = Number(w4);
   //    let w5 = Number(params.row.weekly5);
   //    let w3 = Number(params.row.weekly3);
   //    let hasError = false;
   //    setWeek4(w4);
   //    if(!w4 && w4!==0) {
   //       dispatch(setState("isError", true));
   //       dispatch(setState("isError_Info", "Only numbers are allowed."));
   //       return;
   //    }

   //    if(w3 > w4) {
   //       hasError = true;
   //    }
   //    else if(w4 > w5) {
   //       hasError = true;
   //    }
   //    dispatch(setState("gridDataChanged", true));
   //    updateGrid(hasError, w4);
   //    dispatch(setTotalValues());
   // }

   const debouncedUpdate = useMemo(
      () =>
         debounce((hasError, w4) => {
            dispatch(setState("gridDataChanged", true));
            updateGrid(hasError, w4);
            dispatch(setTotalValues());
         }, QUOTA_CELL_DEBOUNCE_MS),
      [
         params.row?.customerID,
         params.row?.customerGroupID,
         params.row?.productGroupID,
         params.row?.skuid,
         params.row?.depletionModel,
         isFourWeekPeriod,
         dispatch,
      ]
   );

   useEffect(() => {
      return () => debouncedUpdate.cancel();
   }, [debouncedUpdate]);

   function updateWeek4(event) {
      let raw = removeComma(event.target.value);
      setDraft(raw);
      let w4 = Number(raw);
      const live =
         findGridRowByCustomerSku(gridDataFilteredRef.current, params.row) ??
         findGridRowByCustomerSku(gridDataRef.current, params.row) ??
         params.row;
      const dmLive = rowDepletionModelKey(live);
      let w5 = Number(live.weekly5);
      const quota = Number(live.quota);
      let hasError = false;
      if(!w4 && w4!==0) {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Only numbers are allowed."));
         return;
      }

      if (dmLive !== "none" && dmLive !== "biweekly") {
         if (isFourWeekPeriod) {
            if (w4 !== quota) {
               hasError = true;
            }
         } else if (w4 > w5) {
            hasError = true;
         }
      }
      debouncedUpdate(hasError,w4);
   }

   function handleValidity(w3, w4, w5){
      if (rowDm === "none" || rowDm === "biweekly") {
         return;
      }
      const quota = Number(params.row.quota);
      if (isFourWeekPeriod) {
         if (Number(w4) !== quota) {
            dispatch(setState("isError", true));
            dispatch(setState("isError_Info", "Must equal quota"));
         }
      } else if (Number(w4) > Number(w5)) {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Must be less or equal to Week5"));
      }
   }

   if (shouldShowBlankWeekPlaceholder(4, params.row, gridDataFiltered)) {
      return <Box sx={{ width: 100 }} />;
   }

   return (
      <TextField
         variant="standard"
         disabled={rowIsWeek4OnlyForExport(params.row, isWeek4Only)}
         value={displayValue}
         className={
            rowDm !== "none" && rowDm !== "biweekly"
               ? isFourWeekPeriod
                  ? Number(params.row.weekly4) !== Number(params.row.quota)
                     ? "red-row"
                     : ""
                  : Number(params.row.weekly4) > Number(params.row.weekly5)
                     ? "red-row"
                     : ""
               : ""
         }
         onChange={updateWeek4}
         onFocus={onFocus}
         onBlur={() => {
            debouncedUpdate.flush();
            onBlur();
            handleValidity(params.row.weekly3, params.row.weekly4, params.row.weekly5);
         }}
         sx={{ width: 100 }}
      />
   );
}
